<template>
  <div class="flex justify-center">
    <skeleton v-if="data.objectID === 'skeleton'" shape="circle" size="1.5rem" />
    <cell-tooltip v-else-if="data.objectID !== 'skeleton' && orders.length > 0" :label="`${orders.length}`">
      <template #tooltip>
        <div class="flex flex-col gap-2.5 w-full">
          <div v-for="(orderList, statusIndex) in groupedOrders" :key="statusIndex">
            <div class="flex flex-col gap-2.5 w-full">
              <div class="flex items-center gap-2">
                <span class="font-montserrat text-university-primary text-sm font-semibold">Status:</span>
                <component :is="getParticipantStatusIcon(orderList[0].label)?.value" />
                <span class="font-montserrat text-university-primary text-sm font-medium">{{
                  orderList[0].label
                }}</span>
              </div>
              <div class="pl-4">
                <ul class="list-disc list-outside text-sm font-montserrat text-university-primary">
                  <li
                    v-for="(session, sessionIndex) in sessions(orderList)"
                    :key="sessionIndex"
                    class="w-full whitespace-normal break-words"
                  >
                    {{ session.name ?? "" }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </template>
    </cell-tooltip>
  </div>
</template>
<script setup>
import { computed } from "vue";

import Skeleton from "primevue/skeleton";

import { orderStatusLabel, getParticipantStatusIcon } from "../participantStatus";
import CellTooltip from "../Display/CellTooltip.vue";

const props = defineProps({
  data: {
    type: Object,
    default: undefined,
  },
});

const orders = computed(() => {
  return props.data?.orders ?? [];
});

const groupedOrders = computed(() => {
  return orders.value.reduce((groups, order) => {
    const label = orderStatusLabel(order);
    if (!groups[label]) {
      groups[label] = [];
    }
    groups[label].push({ ...order, label: label });
    return groups;
  }, {});
});

const sessions = (orderList) => {
  return orderList.map((order) => order.session);
};
</script>
